import { render, staticRenderFns } from "./IpaamLogo.vue?vue&type=template&id=47965eb5&scoped=true&"
var script = {}
import style0 from "./IpaamLogo.vue?vue&type=style&index=0&id=47965eb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47965eb5",
  null
  
)

export default component.exports